export const flippersSelector = (state: RootState) => state.flippers.flippers;
export const wellnessIdSelector = (state: RootState) => state.userProfile.userProfileData.wellness_id;
